var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { ThemeContext } from "../../styled";
var useEffect = React.useEffect, useContext = React.useContext, useState = React.useState;
/**
 * This hook returns true whenever the the media query for min-width for the specific breakpoint passes
 *
 * @param breakpoint Breakpoint to check
 */
var isBreakpoint = function (key) {
    return ['mobile', 'tablet', 'desktop', 'smallscreen'].includes(key);
};
export function useBreakpoint(breakpoint) {
    var theme = useContext(ThemeContext);
    var mediaQuery = React.useMemo(function () {
        return window.matchMedia("(min-width: " + (isBreakpoint(breakpoint) ? theme.breakpoints[breakpoint] : breakpoint) + ")");
    }, [breakpoint, theme]);
    var _a = __read(useState(mediaQuery.matches), 2), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var listener = function () {
            setValue(mediaQuery.matches);
        };
        mediaQuery.addListener(listener);
        return function () {
            mediaQuery && mediaQuery.removeListener(listener);
        };
    }, [breakpoint, mediaQuery]);
    return value;
}
//# sourceMappingURL=useBreakpoint.js.map